import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "@/routeTree.gen";
import { useAuth } from "@clerk/clerk-react";
import { useAuthentication } from "./hooks/useAuthentication";

const router = createRouter({ routeTree });

function App() {
  useAuthentication();
  const { userId } = useAuth();

  if (userId === undefined) {
    return <div>Loading...</div>;
  }

  return <RouterProvider router={router} />;
}

export default App;
